var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row expanded collapse"},[_c('div',{staticClass:"medium-1 columns border-helper"},[_c('left-menu')],1),_c('div',{staticClass:"medium-11 columns border-helper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }